// Deferred Font Awesome kit loader.
//
// The FA kit script injects its own render-blocking <link rel="stylesheet">
// (kit.css, from ka-p.fontawesome.com) at runtime. Loaded eagerly on mount it
// lands two stylesheets on the critical path (Lighthouse flags it "render-blocking,
// ~780ms") and its evaluation sits in the Total-Blocking-Time window.
//
// The above-the-fold icons it powers (the mobile hamburger, the header
// user-gear/envelope) are decorative, not the LCP element. So we defer the kit
// until the browser is idle — off the critical render path — but, unlike GTM
// (loadGTM.js), we do NOT gate it on user interaction: the hamburger must be
// visible without a tap. requestIdleCallback loads it automatically once the main
// thread settles, with a timeout so it still arrives promptly on busy devices.

const KIT_SRC = 'https://kit.fontawesome.com/c378a65ddc.js';

let injected = false;

function injectFontAwesome() {
  if (injected) return;
  injected = true;

  const script = document.createElement('script');
  script.src = KIT_SRC;
  script.crossOrigin = 'anonymous';
  document.head.appendChild(script);
}

export function loadFontAwesome() {
  if (typeof window === 'undefined') return;

  if ('requestIdleCallback' in window) {
    window.requestIdleCallback(injectFontAwesome, { timeout: 2500 });
  } else {
    // Safari has no requestIdleCallback — fall back to a short timeout that still
    // clears the initial render/TBT burst.
    setTimeout(injectFontAwesome, 1500);
  }
}
